import { render, staticRenderFns } from "./ChatClusterHome.vue?vue&type=template&id=446a23ae&"
import script from "./ChatClusterHome.vue?vue&type=script&lang=js&"
export * from "./ChatClusterHome.vue?vue&type=script&lang=js&"
import style0 from "./ChatClusterHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports